import { render } from "./ToolsComponent.vue?vue&type=template&id=4c6c2b62&scoped=true"
import script from "./ToolsComponent.vue?vue&type=script&lang=js"
export * from "./ToolsComponent.vue?vue&type=script&lang=js"

import "./ToolsComponent.vue?vue&type=style&index=0&id=4c6c2b62&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c6c2b62"]])

export default __exports__